export default function throwForFalsy(value?: string | null): string {
  if (!value) {
    throw new Error(
      'Value not expected to be falsy. Check the stacktrace to locate the source.',
    );
  }

  return value;
}
